import { useRolodexEntries } from 'features/rolodex'
import React from 'react'
import styled from 'styled-components'
import { useGeckoTheme } from 'styles/GeckoTheme'
import { GeckoInspection, GeckoPublishingState, RolodexEntryType } from 'types'

export const TextSm = styled.p`
  font-size: 0.75rem;
  line-height: 1rem;
`

export const Tag = styled(TextSm)<{ $background?: string }>`
  background: ${({ theme, $background }) =>
    $background ? $background : theme.forecast.hoverGhostButton};
  border-radius: 0.25rem;
  padding: 0 0.25rem;
`

export enum InspectionStatus {
  InspectionComplete = 'Inspection Complete',
  InspectionInProgress = 'Inspection in Progress',
  Scheduled = 'Scheduled',
  DataFinalized = 'Data Finalized',
  DataInQA = 'Data in QA',
}

export const CDSTag: React.FC<{ inspection: GeckoInspection }> = ({
  inspection,
}) => {
  const { theme } = useGeckoTheme()
  const { componentDatasets } = useRolodexEntries({
    type: RolodexEntryType.COMPONENT_DATASET,
    tags: { inspection: [inspection.id] },
  })

  const cdsStatus = componentDatasets.reduce((previousValue, currentValue) => {
    if (
      previousValue === InspectionStatus.DataFinalized ||
      currentValue.data.publishing_state.id ===
        GeckoPublishingState.Finalized.id
    ) {
      return InspectionStatus.DataFinalized
    } else if (
      previousValue === InspectionStatus.DataInQA ||
      currentValue.data.publishing_state.id === 'working'
    ) {
      return InspectionStatus.DataInQA
    } else if (
      previousValue === InspectionStatus.InspectionInProgress ||
      currentValue.data.publishing_state.id === 'raw'
    ) {
      return InspectionStatus.InspectionInProgress
    } else {
      return InspectionStatus.Scheduled
    }
  }, InspectionStatus.Scheduled)

  const getBackgroundColor = (status: string) => {
    switch (status) {
      case InspectionStatus.DataFinalized:
        return theme.common.badge.background.darkGreen
      case InspectionStatus.DataInQA:
        return theme.common.badge.background.green
      case InspectionStatus.InspectionInProgress:
        return theme.common.badge.background.yellow
      case InspectionStatus.Scheduled:
        return theme.common.badge.background.gray
      case InspectionStatus.InspectionComplete:
        return theme.common.badge.background.blue
      default:
        return theme.forecast.hoverGhostButton
    }
  }

  return <Tag $background={getBackgroundColor(cdsStatus)}>{cdsStatus}</Tag>
}
